export enum PresetOptionEnum {
  Today = 'Today',
  Yesterday = 'Yesterday',
  ThisWeek = 'This week',
  Last7Days = 'Last 7 days',
  Last30Days = 'Last 30 days',
  Last90Days = 'Last 90 days',
  Last365Days = 'Last 365 days',
}
